import jQuery from 'jquery';
import _one from 'oneall';
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import App from './components/App.vue';
import VueI18n from 'vue-i18n'
import LFPortal from './portal/portal.js'
import messages from './vocab'
import vueSmoothScroll from 'vue-smooth-scroll'
// import VueAnalytics from 'vue-analytics'


jQuery(document).ready(function($) {
	Vue.use(VueI18n);
	Vue.use(VueClipboard);
	Vue.use(vueSmoothScroll);

	// Create VueI18n instance with options
	const i18n = new VueI18n({
	  locale: LFPortal.dataset.langid, // set locale
	  messages, // set locale messages
	  fallbackLocale: 'en',
	  numberFormats:{
		  'en': {
		    currency: {
		      style: 'currency', currency: 'EUR', currencyDisplay: 'symbol', minimumFractionDigits: 0
		    }
		  }
		},
	  silentTranslationWarn: true
	})

	LFPortal.init(i18n, (window._P || []));

	var vue_el_id = "#"+LFPortal.containerid("vueapp");
	var vue_render_app = false;
	if($(vue_el_id).length == 1){
		vue_render_app = true;
		// console.log('Found an App container on this page "%s"', vue_el_id);
	}else{
		// console.log('No App container on this page "%s"', vue_el_id);
	}


	// We need to mount the app even if we don't want to render it as we rely on Vue.updated() to call Portal.save().
	var vm = new Vue({
		i18n,
	  el: (vue_render_app?vue_el_id:null),
	  render: h => h(App),
	  data: LFPortal.dataset
	}).$mount();

	// console.log("Post VUE");

	// Seup oneall api
	_one.push(['social_login', 'set_providers', ['google','facebook','linkedin','twitter']]);
	// _one.push(['social_login', 'set_providers', ['google','linkedin','twitter']]);
	// Login using a redirect
	_one.push(['social_login', 'set_callback_uri', document.location.origin + '/oneallcallback/?current_page='+encodeURIComponent(document.location.href)]);
	// Put the social signin options into the named element
	_one.push(['social_login', 'do_render_ui', 'oa_social_login_options']);
	
	// _one.push(['social_link', 'set_providers', ['google','linkedin']]);
 //  _one.push(['social_link', 'set_callback_uri', document.location.origin + '/oneallcallback/?current_page='+encodeURIComponent(document.location.href)]);
 //  _one.push(['social_link', 'set_user_token', user_token]);
 //  _one.push(['social_link', 'do_render_ui', 'oa_social_link_container']);

	// Could maybe move this into LFPortal
	// SSO is not enabled for Oneal basic level accounts
	/*
	if(LFPortal.sso_session_token && LFPortal.sso_session_token.length){
		// We have an SSO token : Register a new session
		// console.log("SSO:", LFPortal.sso_session_token);
		_one.push(['single_sign_on', 'do_register_sso_session', LFPortal.sso_session_token]); 
	}else{
		// We don't have an SSO token : Try to auto login
		// console.log("Try for SSO");
		_one.push(['single_sign_on', 'set_callback_uri', document.location.origin + '/callback.cfm?current_page='+encodeURIComponent(document.location.href)]);
		// Redirects the user to the callback_uri if he is logged in on another of your websites
		_one.push(['single_sign_on', 'do_check_for_sso_session']);
	}
	*/

	window._P = LFPortal;
});





// WEBPACK FOOTER //
// ./src/main.js